<template> 
  <div>    
    <barraprincipal @abrir="mtMenuVisible"></barraprincipal>   
    <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>  

    <v-row>
     <v-col class="d-flex justify-center"> <h1>Panel principal del alumno</h1 ></v-col>
    </v-row>


  </div>
</template>

<script>

import menulateral from '@/components/MenuLateral'
import barraprincipal from '@/components/BarraPrincipal'


export default {
  components:{
    menulateral,
    barraprincipal
  },
  data() {
    return {
      menu_visible: false
    }
  },

  created() {

    const datos = {
        nombre: sessionStorage.getItem('nombre'),
        apellido_paterno: sessionStorage.getItem('apellido'),
        apellido_materno: "",
        no_control: "",        
        correo: sessionStorage.getItem('correo'),
        telefono: ""
    }

    if(this.correo != '' && this.correo != null)
      this.axios.post(this.$url+'/alumno/alta', {datos:datos})
        
  },

  methods: {
    mtMenuVisible(value){
      this.menu_visible = value
    },
  },

  
};

</script>